if (!customElements.get('bd-information-page')) {
  customElements.define('bd-information-page', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const { signal } = this.controller;
      this.querySelectorAll('[data-information-map]').forEach(details => {
        details.addEventListener('toggle', () => {
          if (!details.open) return;
          const frame = details.querySelector('iframe');
          if (!frame) return;
          try {
            const url = new URL(frame.dataset.mapSrc);
            if (url.protocol !== 'https:' || !(url.hostname === 'google.com' || url.hostname.endsWith('.google.com'))) return;
            if (!frame.getAttribute('src')) frame.src = url.href;
            frame.hidden = false;
          } catch { /* Native directions remain available. */ }
        }, { signal });
      });
      this.querySelectorAll('[data-review-load]').forEach(button => {
        button.addEventListener('click', async () => {
          const id = button.dataset.reviewLoad;
          if (!/^[a-f0-9-]{36}$/i.test(id)) return;
          const panel = button.closest('[data-review-panel]');
          const status = panel.querySelector('[data-review-status]');
          const content = panel.querySelector('[data-review-content]');
          button.disabled = true;
          status.textContent = status.dataset.loadingText;
          if (!content.firstElementChild) {
            const widget = document.createElement('div');
            widget.className = `elfsight-app-${id}`;
            widget.setAttribute('data-elfsight-app-lazy', '');
            content.append(widget);
          }
          try {
            if (!window.bdStoreReviewsLoader) {
              window.bdStoreReviewsLoader = new Promise((resolve, reject) => {
                const script = document.createElement('script');
                script.src = 'https://elfsightcdn.com/platform.js';
                script.async = true;
                script.onload = resolve;
                script.onerror = () => { script.remove(); window.bdStoreReviewsLoader = null; reject(new Error('Reviews unavailable')); };
                document.head.append(script);
              });
            }
            await window.bdStoreReviewsLoader;
            button.hidden = true;
            status.textContent = '';
          } catch {
            status.textContent = status.dataset.failedText;
            button.disabled = false;
          }
        }, { signal });
      });
      this.querySelectorAll('[data-information-body] table').forEach(table => {
        if (table.parentElement.classList.contains('bd-information-table')) return;
        const wrapper = document.createElement('div');
        wrapper.className = 'bd-information-table';
        wrapper.tabIndex = 0;
        wrapper.setAttribute('role', 'region');
        wrapper.setAttribute('aria-label', table.caption?.textContent || this.dataset.tableLabel || 'Table');
        table.before(wrapper); wrapper.append(table);
      });
      const toc = this.querySelector('[data-information-toc]');
      const headings = [...this.querySelectorAll('[data-information-body] h2')];
      if (toc && headings.length > 2) {
        const nav = toc.querySelector('nav');
        nav.replaceChildren();
        headings.forEach((heading, index) => {
          if (!heading.id) heading.id = `${this.id}-topic-${index + 1}`;
          const link = document.createElement('a');
          link.href = `#${heading.id}`; link.textContent = heading.textContent;
          nav.append(link);
        });
        toc.hidden = false;
      }
    }
    disconnectedCallback() { this.controller?.abort(); this.controller = null; }
  });
}
